import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
declare let ClientIP: any;

@Injectable({
  providedIn: 'root'
})
export class ClientipService {
  IPAddress: any;

  constructor(public _http: HttpClient) {
    this._http.get<any>('https://api.ipify.org?format=json').subscribe({
      next: (data) => {
        const serverIp = data.ip;
        const privateIP = ClientIP; // You must ensure this is set somewhere else in your app
        const IP = serverIp + ':' + privateIP;
        this.IPAddress = IP;
        console.log('Full IP:', this.IPAddress);
      },
      error: (err) => {
        console.error('Failed to fetch public IP:', err);
      }
    });
  }
}
